var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.direction ? 'k-rtl' : '' ]},[_c('ul',{class:[_vm.direction ? 'k-rtl' : '' ,'rayvarzBPMSContextMenu']})])}
var staticRenderFns = []

export { render, staticRenderFns }